// extracted by mini-css-extract-plugin
export var borderCol = "persons-episode-module--borderCol--6ab6b";
export var items = "persons-episode-module--items--08a6a";
export var linkProfile = "persons-episode-module--linkProfile--44f7a";
export var name = "persons-episode-module--name--44f1c";
export var roundImage = "persons-episode-module--roundImage--b313a";